import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import { useEffect, useState } from 'react';
import useDebounce from '../../../../hooks/use-debounce';
import { UnitService } from '../../../../models/unit-service';

interface ProjectsTabProps {
  unitID: number;
}

const DEFAULT_GROUP = [
  {
    field: 'serviceGroupName',
  },
];

export const ServicesTab = ({ unitID }: ProjectsTabProps) => {

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('UnitDetailService', 'UnitDetailService')
  );

  const { isLoading, data: UnitServices, refetch } = useLoadData<ApiResponse<UnitService[]>>(servicesApiKeyStore.getServiceUnitMappings(unitID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnitServices, setFilteredUnitServices] = useState<UnitService[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitServiceList = UnitServices?.data?.filter((UnitService) =>
      Object.values(UnitService).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnitServices(filteredUnitServiceList || []);
  }, [debouncedSearchTerm, UnitServices?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'UnitDetailService',
      pageName: 'UnitDetailService',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'UnitDetailService',
      pageName: 'UnitDetailService',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  return (
    <SiTrackGrid
      fileTitle='unit_service'
      columns={columns}
      dataItemKey="serviceID"
      // queryConfig={servicesApiKeyStore.getServiceUnitMappings(unitID)}
      // defaultGroup={DEFAULT_GROUP}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      isBusy={isLoading || isLoadingGridLayout}

      // -----------------Grid Layout-------
      dataItems={filteredUnitServices || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
